export default __webpack_public_path__ + "static/media/logo.25c37c92.jpg";